import { Award } from "lucide-react";

export const AwardBanner = () => {
  return (
    <div
      data-testid="award-banner"
      className="bg-green-900 text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3.5 flex items-center justify-center gap-3 text-center">
        <Award className="w-5 h-5 text-amber-400 shrink-0" />
        <p className="text-sm sm:text-base font-semibold tracking-wide">
          <span className="text-amber-400">Award-Winning</span> Pond &amp; Garden Care
          <span className="hidden sm:inline text-white/80 font-medium">
            {" "}— Silver Gilt, Horticultural Trade Stand, South of England Show
          </span>
        </p>
        <Award className="w-5 h-5 text-amber-400 shrink-0 hidden sm:block" />
      </div>
    </div>
  );
};

export default AwardBanner;
